import SsoActionTypes from './sso.types';
import { getParameterByName } from '../../utils/commonFunctions';

let token = getParameterByName('token');
let referer = getParameterByName('referer');
let returnPath = getParameterByName('return_path');
let sso = 1;

const courseId = getParameterByName('course_id', returnPath)
localStorage.setItem('active_course_id', courseId)
localStorage.setItem('enLogout', '');

if(courseId === '652' || courseId === '653' || courseId === '658' || courseId === '659') {
	let amp = returnPath.indexOf('&')
	returnPath = getParameterByName('return_path').slice(0, amp)
}

if (typeof token === undefined) {
	window.location.href = 'login';
}
if (referer === 'landing') {
	sso = 0;
	localStorage.setItem('TriggerBuyNow', 'Yes');
	localStorage.setItem('is_subscription', getParameterByName('is_subscription'));
	localStorage.setItem('payment_method', getParameterByName('payment_method'));
	localStorage.setItem('new_user', getParameterByName('new_user'));
	localStorage.setItem('referer', referer);
	localStorage.setItem('paymentInProcess', 1);
} else if (referer === 'uap') {
	sso = 1;
	localStorage.setItem('disableTemplate', 1);
	localStorage.setItem('uap_returnPath', returnPath);
	localStorage.setItem('uap_callback', getParameterByName('callbackurl'));
	localStorage.setItem('roomID', getParameterByName('proctorId'));
	localStorage.setItem('taskID', getParameterByName('taskId'));
	localStorage.setItem('LTproctorToken', getParameterByName('proctorToken'));
	localStorage.setItem('enLogout', getParameterByName('logout'));
	localStorage.setItem('CallproctorToken', '');
	//get assessmentID from the callback url
	var newURL=getParameterByName('callbackurl')
	var splitURL=newURL.toString().split("?");
	var AssessID=splitURL[0].toString().split("/");
	localStorage.setItem('AssessID', AssessID[5]);
} else {
	sso = 1;
}
returnPath = (!!returnPath ? returnPath : '/mydashboard').split('?');

const initialSsoState = {
	error: '',
	success: false,
	token,
	sso,
	returnPath: returnPath[0],
	returnSearch: !!returnPath[1] ? '?' + returnPath[1] : '',
	referer,
};

export const ssoDetails = (state = initialSsoState, action = {}) => {
	switch (action.type) {
		case SsoActionTypes.VALIDATE_USER.SUCCESS:
			return Object.assign({}, state, { success: true });
		default:
			return state;
	}
};
